import { Outlet, ScrollRestoration } from "react-router";

import styles from "./Layout.module.scss";
import { ReactNode } from "react";
import usePageViewTracker from "../../hooks/usePageViewTracker";

type LayoutProps = {
  children?: ReactNode;
};

const Content = ({ children }: LayoutProps) => {
  usePageViewTracker();

  return (
    <main id="content" className={styles.content}>
      <Outlet />
      <ScrollRestoration />
      {children}
    </main>
  );
};

export default Content;
